import gql from 'graphql-tag';

const ourWorkQuery = gql`
  query OurWork {
    ourWork {
      backgroundColour
      description
      displayText
      enableGradient
      featureImage {
        urls
      }
      markdownBody {
        html
      }
      tags
      caseStudyLink {
        url
        text
      }
    }
  }
`;

export {
  ourWorkQuery
}